        import { Injectable } from '@angular/core';
        import { Http, Headers, Response, Request} from '@angular/http';
        import {BehaviorSubject, Observable, Subject, Subscriber,pipe} from 'rxjs';
        import { map } from 'rxjs/operators';
        import {CartService} from '../services/cart.service';
        import {  CommonService } from './../services/common.service';
        import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
          import { isPlatformBrowser } from '@angular/common';
        @Injectable()
        export class AuthService {
            public userdata: any;
            private token: string;
            public userjson: any;
            gdata: any;
            gjson: any;
            private uid: number;
            private uname;
            private uemail;
            private umobile;
            tempcartarray = [];
            useractualdata = [];
            private cstoken: any;
            private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
                           clientcredentialheader = new Headers({'Content-Type':'application/json',
               'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
               'Authorization': this.getClientCredential()});
                authcredheader: any;
            constructor(private http: Http, private cartService: CartService,
                private commonservice: CommonService,@Inject(PLATFORM_ID) private platformId: Object) {}
            getClientCredential(){
                var Bearer= 'Bearer' + ' ' + this.cdtk;
                return Bearer;
              }
            getAuthCredential(){
                if (isPlatformBrowser(this.platformId)) {
                var a = localStorage.getItem("token");
                var tjson =JSON.parse(a);
                if(tjson != null){
                  var auth= 'Bearer' + ' ' +  tjson.token;
                  return auth;
                }
              }
              }
              genAuthHeader(){
                this.authcredheader = new Headers({'Content-Type':'application/json',
                'Accept':'application/json', 
                'Authorization': this.getAuthCredential()})
              }
           
            setRoleId(rid) {
                if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem('roleid', JSON.stringify({ roleid: rid }));
                }
            }
            getRoleId() {
                if (isPlatformBrowser(this.platformId)) {
                const gdata = localStorage.getItem('roleid');
                const gjson = JSON.parse(gdata);
                if (gjson != null) {
                  const rid = gjson.roleid;
                  return rid
                }else {
                  return 0;
                }
            }
            }
            signUp(name: string, email: string, mobile: string, bio: string,image:string,gender:string, role_id:number,
                dob: string, remember_token: string, password: string, ip , source) {
                return this.http.post('https://passport.petcart.in/register',
                    {name:name,email:email,mobile:mobile,bio:bio,gender:gender,dob:dob,remember_token:
                    remember_token,password:password,image:image, ip: ip, source: source},
                    {headers: this.clientcredentialheader})
                    .pipe(
                     map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const token = response.json() && response.json().token;
                    if (token) {
                        // set token property
                        if (isPlatformBrowser(this.platformId)) {
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('token', JSON.stringify({ token: token }));
                        }
                        this.getUserdata(email);
                    // return true to indicate successful login
                        return true;
                    } else {
                        // return false to indicate failed login
                        return false;
                    }
                })
             );
            }

                Signin(email: string, password: string) {
                return this.http.post('https://passport.petcart.in/login',
                    {email: email, password: password},
                    {headers: this.clientcredentialheader})
                    .pipe(
                   map((response: Response) => {
                                // login successful if there's a jwt token in the response

                                const token = response.json() && response.json().token;
                                if (token) {
                                    // set token property
                                    this.token = token;
                                    if (isPlatformBrowser(this.platformId)) {
        // store username and jwt token in local storage to keep user logged in between page refreshes
                                    localStorage.setItem('token', JSON.stringify({ token: token }));
                                    }
                                    var data = email;
                                    var check= this.isANumber(data);
                                    if (check === false ){
                                      this.getUserdata(email);
                                    } else {
                                      this.getUserdata2(email);
                                    }

                                    // store the email address
                                 // return true to indicate successful login
                                    return true;
                                }
                                if (!token) {
                                    return false;
                                }
               })
            );
          }

          serviceproviderLogin(email: string, password: string) {
            return this.http.post('https://passport.petcart.in/serviceproviderlogin',
                {email: email, password: password},
                {headers: this.clientcredentialheader})
                .pipe(
                  map((response: Response) => {
                            // login successful if there's a jwt token in the response

                            const token = response.json() && response.json().token;
                            if (token) {
                                // set token property
                                this.token = token;
                                if (isPlatformBrowser(this.platformId)) {
    // store username and jwt token in local storage to keep user logged in between page refreshes
                                localStorage.setItem('token', JSON.stringify({ token: token }));
                                }
                                this.getUserdata(email);
                                // store the email address
                             // return true to indicate successful login
                                return true;
                            }
                            if (!token) {
                                return false;
                            }
           })
        );
      }
     checkUserTempData() {
        if (isPlatformBrowser(this.platformId)) {
         const tempuserdata = localStorage.getItem('idata');
         const temuserjson = JSON.parse(tempuserdata);
         if ( temuserjson != null) {
             const tempuid = temuserjson.uid;
             return tempuid;
        }
       }
     }
     passwordReset(email , pass) {
        return this.http.post('https://passport.petcart.in/login',
        {email: email, password: pass},
        {headers: this.clientcredentialheader})
        .pipe(
        map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const token = response.json() && response.json().token;
                    if (token) {
                        // set token property
                        this.token = token;
                        return true;
                    }
                    if (!token) {
                        return false;
                    }
            })
        );
     }
     changePassword(userid , pass) {
         this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + userid,
                {password: pass},
                {headers: this.authcredheader})
                .pipe(
                map( (response: Response) => {
                    return response.json().data;
                })
            );
     }
    
            logout(): void {
                if (isPlatformBrowser(this.platformId)) {
                // clear token remove user from local storage to log user out
                this.token = null;
                localStorage.removeItem('currentUser');
                localStorage.removeItem('token');
                localStorage.removeItem('roleid');
                localStorage.removeItem('activatepath');
                localStorage.clear();
                }
            }
            getToken() {
                if (isPlatformBrowser(this.platformId)) {
            this.userdata = localStorage.getItem('currentUser');
            this.userjson = JSON.parse(this.userdata);
            if (this.userjson != null) {
            this.userjson = JSON.parse(this.userdata);
            this.token = this.userjson.token;
            return(this.token);
            }
        }
            }

         

            getUserdata(email) {
                this.cartService.getUserData(email)
                .subscribe(
                    (x) => {
                        if (isPlatformBrowser(this.platformId)) {
                        // tslint:disable-next-line:max-line-length
                        localStorage.setItem('currentUser', JSON.stringify({ uid: x[0].id, uname: x[0].name, umobile: x[0].mobile, uemail: x[0].email}));
                        this.commonservice.loginsuccess.next(1);
                        }
                    });
           }

           getUserdata2(mobile) {
            this.cartService.getUserDataByMobile(mobile)
            .subscribe(
              (x) => {
                  if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('currentUser', JSON.stringify({ uid: x[0].id, uname: x[0].name,
                 umobile: x[0].mobile, uemail: x[0].email}));
              this.commonservice.loginsuccess.next(1);
            }
            });
            }
           updateUserName(id, name) {
               this.genAuthHeader();
            return this.http.put('https://passport.petcart.in/users/' + id,
            { name: name}, {headers: this.authcredheader})
           .pipe(map(
             (response: Response) => {
               const token = response.json() && response.json().token;
               if (token) {
                   // set token property
                   this.token = token;
// store username and jwt token in local storage to keep user logged in between page refreshes
if (isPlatformBrowser(this.platformId)) {
                   localStorage.setItem('token', JSON.stringify({ token: token }));
}
                   this.getUserdata(name);
                   // store the email address
                // return true to indicate successful login
                   return true;
               }
               if (!token) {
                   return false;
               }
             })
            );
          }

          isANumber(str) {
            return !/\D/.test(str);
          }

          tempuid(tempuid) {
              this.genAuthHeader();
              return this.http.post('https://passport.petcart.in/modifycartatsigninorsignup',
            {tempuserid: tempuid},
            {headers: this.authcredheader})
            .pipe(
             map(
              (response: Response) => {
              return response.json().data;
              })
            );
            }
          
        }
